import { css } from 'styled-components';
import {
  getSpacing, SpacingName, BreakpointQueryName, ThemedFunctor,
} from '@doveit/lego';
import variables from '../../themes/variables';

export const articleBlock = css`
  position: relative;
`;

export const anchorList: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  padding-left: 1rem;
  list-style: disc;
`;

export const anchorListItem: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
`;

// CSS trick to avoid that the anchored section appears under the main navigation
export const anchor: ThemedFunctor = ({ theme }) => css`
  position: absolute;
  margin-top: -${variables.navigationHeight.mobile};

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    margin-top: -${variables.navigationHeight.desktop};
  }
`;

export const breadcrumb: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, 0])}
  border-top: 1px solid ${theme.palettes.neutrals.light};
`;
